import {Query, Store} from "@datorama/akita"
import {isDev, isTest} from "utils/isDev"

export const akitaCypressQueryBinding = (query: Query<any>) => {
  if (!isDev() && (!isTest() || !window.Cypress)) return
  const name = query.constructor.name
  query.select().subscribe(_ => window[name] = query.getValue())
}

export const akitaCypressStoreBinding = (store: Store) => {
  if (!isDev() && (!isTest() || !window.Cypress)) return
  const name: string = store.constructor.name
  window[name] = store
}
